import { render } from "./ToolBar.vue?vue&type=template&id=1cad5812&scoped=true&ts=true"
import script from "./ToolBar.vue?vue&type=script&lang=ts"
export * from "./ToolBar.vue?vue&type=script&lang=ts"

import "./ToolBar.vue?vue&type=style&index=0&id=1cad5812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cad5812"]])

export default __exports__